module.exports = __webpack_public_path__ + "img/a3.adab6c80.webp";